<script setup lang="ts">
import type { Question } from '../types/questionnaire'
import ShortTextQuestion from './ShortTextQuestion.vue'
import SingleChoiceQuestion from './SingleChoiceQuestion.vue'

defineProps<{
  question: Question
  modelValue: string
  customValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
  'update:customValue': [value: string]
}>()
</script>

<template>
  <SingleChoiceQuestion
    v-if="question.type === 'single_choice'"
    :question="question"
    :model-value="modelValue"
    :custom-value="customValue"
    @update:model-value="emit('update:modelValue', $event)"
    @update:custom-value="emit('update:customValue', $event)"
  />
  <ShortTextQuestion
    v-else-if="question.type === 'short_text'"
    :question="question"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>

